import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit';
import { isNumber } from 'lodash';
import { showNotification } from 'shared/components/Notification';

/**
 * Log a warning and show a toast!
 */
export const rtkQueryErrorLogger: Middleware = () => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const { status, originalStatus, error, data } = action.payload;
    const errorObject = { message: 'Unknown Error', code: '500' };

    if (error) {
      errorObject.message = error;
    } else if (data) {
      errorObject.message = data;
    }

    if (isNumber(status)) {
      errorObject.code = status.toString();
    } else if (originalStatus) {
      errorObject.code = originalStatus;
    }

    showNotification({ errorObject });
  }

  return next(action);
};
